// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Subsonic__Album from "./album.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(id) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  }, Subsonic__Utils.makeRequest({
    _method: "rest/getAlbum",
    params: params
  }, Subsonic__Album.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.album
    };
  }));
}

export {
  make,
}
/* No side effect */
